import { Box, Flex } from "@radix-ui/themes";
import { SymbolLogo } from "@/components/logo/SymbolLogo";
import { useAutoHideHeader } from "@/hooks/useAutoHideHeader";
import { useRouter } from "next/router";

export const BusinessCardHeader = ({ flipped }: { flipped: boolean }) => {
  const router = useRouter();

  const hidden = useAutoHideHeader();

  return (
    <Flex
      justify={"between"}
      className={`header ${hidden ? "header-hidden" : ""}`}
      style={{
        visibility: flipped ? "visible" : "hidden",
      }}
    >
      <Box
        className={"cursor-pointer w-12"}
        onClick={() => {
          router.push("/", undefined, { scroll: false });
        }}
      >
        <SymbolLogo />
      </Box>
    </Flex>
  );
};
